// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"input_inputContainer__Cwmbl","label":"input_label__2hvqO","inputClass":"input_inputClass__29Gxd"};